import { useState } from "react";
import { Col, Row } from "antd";
import AssetPath from "../../../AssetPath/AssetPath";
import ModalBox from "../../../Components/ModalBox/ModalBox";

export default function PharmaSosHyderabadSpeakers() {
  const [open, setOpen] = useState(false);
  const [showData, setShowData] = useState("");

  const handleShowData = (items) => {
    setShowData(items);
    setOpen(true);
  };

  const SpeakersData = [
    {
      name: "Arnav Singh",
      position: "Lead Data Scientist",
      companyName: "Chryselys",
      profileImage: AssetPath.conferenceHyderabad.arnavSingh,
      desc: (
        <>
          <p>
            Arnav Singh is a data scientist with 8 years of experience
            leveraging machine learning, statistical modeling, and big data
            technologies to solve complex challenges in the pharmaceutical
            domain. He has developed and deployed advanced models for Next Best
            Action, call planning, and personalized HCP-level insights, driving
            impactful outcomes in healthcare.
          </p>
        </>
      ),
    },
    {
      name: "Ganpat Anchaliya",
      position: "Senior GCC Leader",
      companyName: "Novartis Corporate Center Hyderabad",
      profileImage: AssetPath.conferenceHyderabad.GanpatAnchaliya,
      desc: (
        <>
          <p>
            Ganpat Anchaliya leads the largest Corporate Centre for Novartis at
            Hyderabad, which comprises approximately 8500+ associates,
            representing about 10% of the global workforce at Novartis. With the
            aim of reimagining medicine through breakthrough technology and AI
            capabilities, Ganpat's strategic focus is to enable Novartis' vision
            of leading digital transformation with significant contributions
            from Novartis' Corporate Center (NOCC) Hyderabad. Ganpat joined
            Novartis about 17 years ago when the Hyderabad office comprised just
            300 employees. Through his contributions in multiple roles within
            the Finance team, he has actively participated in the growth and
            expansion of NOCC Hyderabad.
          </p>
          <p>
            His functional experience includes pivotal roles in finance, such as
            Controllership, Accounting & Reporting operations, and managing
            Global Business Partnering roles. He has also overseen substantial
            investment projects, including the Genome Valley Research Lab and
            the NKC office. Ganpat is a qualified Chartered Accountant and
            Company Secretary. Prior to Novartis, he worked with Reliance, NIIT,
            Airtel, and Intas Pharmaceuticals. Beyond his professional
            excellence, Ganpat's hobbies include mango farming, running and
            playing badminton.
          </p>
        </>
      ),
    },

    {
      name: "Mahesh Iyyer",
      position: "Biometrics and Data Sciences",
      companyName: "Bristol-Myers Squibb, India",
      profileImage: AssetPath.conferenceHyderabad.MaherIyer,
      desc: (
        <>
          <p>
            Mahesh is currently Head of Biometrics and Data Sciences at
            Bristol-Myers Squibb, India. Mahesh Iyyer has over 25 years of
            experience in research and development in healthcare and has been
            responsible for guiding many products through the development
            life-cycle throughout his career at Pfizer, Novartis, Bristol Myers
            Squibb and Boehringer-Ingelheim.
          </p>

          <p>
            Prior to his current role at BMS, Mahesh was Head of Stats, AI/ML,
            Quantitative and Digital Sciences, and Innovation, India-Philippines
            at Pfizer. Prior to his Pfizer role, Mahesh was VP at Parexel,
            responsible for heading the Innovation and Technology function for
            Parexel, and was also India Head for Global Data Operations. Mahesh
            has also been a co-founder of Sineflex Solutions LLP, a consulting
            firm focused on enabling and accelerating innovation in the
            healthcare space. He was also the head of the BIRAC funded med-tech
            accelerator located at the Centre for Innovation and
            Entrepreneurship, IIIT Hyderabad. Mahesh continues to be responsible
            for mentoring startups in the med-tech space, and helping them scale
            their products and solutions.
          </p>

          <p>
            Mahesh brings a strong analytical mind-set, deep insights into
            healthcare development and a proven record of implementing
            innovative solutions in the healthcare domain. Mahesh is passionate
            about enhancing industry academia collaboration; he set up one of
            the first part-time Ph.D. programs in Statistics for Novartis
            associates, teaches at a number of Indian universities and has
            chaired multiple conferences over the years. He currently leads the
            AI/ML working group for ISCR. He is Past-President of the Indian
            Association for Statistics in Clinical Trials and Past-President of
            the International Indian Statistical Association, India Chapter. He
            was recently featured in the Top-100 AI leaders in India, and the
            Top-20 Future of Work Icons for AI/ML.
          </p>

          <p>
            Apart from his functional activities, Mahesh has led various
            organizational developmental activities and trainings. He is a
            certified coach in the areas of emotional intelligence, assessment
            centers, and psychometric evaluations. Mahesh has completed his
            Ph.D. in Statistics from Temple University, Philadelphia.
          </p>
        </>
      ),
    },
     {
      name: "Mrinal Duggal",
      position: "",
      companyName: "Head of Sanofi Hyderabad Hub",
      profileImage: AssetPath.conferenceHyderabad.MrinalDuggal,
      desc: (
        <>
          <p>
            Mrinal Duggal is a distinguished leader in Global Business Services
            (GBS) and Global Capability Centers (GCC), with over two decades of
            experience in establishing, scaling, and managing high-performing
            operations. As the Head of the Sanofi Hyderabad Hub, Mrinal has
            played a pivotal role in setting up and expanding the GCC for
            Sanofi, growing the team to over 2500 associates and integrating a
            wide array of functions, including Medical, Digital, Business
            Operations & Strategy, Commercial, People Services, Manufacturing &
            Supply, and Procure-to-Pay.
          </p>

          <p>
            Before her tenure at Sanofi, Mrinal amassed extensive experience
            with leading organizations such as GE Capital, JP Morgan, Novartis,
            and Jardine Lloyd Thompson. Her expertise spans large-scale
            transformation programs, impacting thousands of employees, and
            managing diverse teams across data analytics, project management,
            graphic design, and supply management.
          </p>

          <p>
            Mrinal holds an MBA from the Institute of Management Technology
            (IMT), Ghaziabad, and is a Six Sigma Black Belt. Her academic
            background and practical experience establish her as a thought
            leader in the GBS and GCC domains. Mrinal is the proud recipient of
            GCC Workplace Awards 2025 Country Leader of the Year Award and
            Business Innovation Awards 2025 - Women's Power Listing Award.
          </p>
        </>
      ),
    },
    
    {
      name: "Shikha Agarwal",
      position: "Head of Data Engineering",
      companyName: "Chryselys",
      profileImage: AssetPath.conferenceHyderabad.ShikhaAgarwal,
      desc: (
        <>
          <p>
            Shikha is a passionate leader with over 15 years of experience in
            Data Engineering, seamlessly integrating AI-driven strategies,
            fostering thought leadership and innovation grounded in strong
            ethics and values. At Chryselys, she successfully leads the diverse
            Data Engineering team driving growth and building trust with the
            customers.
          </p>
        </>
      ),
    },
    {
      name: "Sudharsan Mohan",
      position: "Associate Director-Products",
      companyName: "Chryselys",
      profileImage: AssetPath.speakers.sudharsanMohan,
      desc: (
        <>
          <p>
            With over 8 years of experience in data science and data
            engineering, Sudharsan Mohan is highly skilled in transforming data
            into actionable insights. His expertise covers data engineering,
            analytics, predictive modeling, business intelligence, product
            development, and Generative AI.
          </p>

          <p>
            Currently leading product development at Chryselys, he focuses on
            driving innovation and strategic advancements through data.
          </p>

          <p>
            Sudharsan has a strong track record of delivering data-driven
            solutions that enhance operational efficiency and accuracy, crafting
            advanced regression and classification models, and solving complex
            business challenges with predictive analytics and data mining.
          </p>
        </>
      ),
    },
    {
      name: "Vikas Gade",
      position: "Lead Business Analytics",
      companyName: "Chryselys",
      profileImage: AssetPath.speakers.vikasGade,
      desc: (
        <>
          <p>
            Vikas is a strategic business consultant with a decade of expertise
            in business insights, analytics, and advanced decision-making
            frameworks.
          </p>

          <p>
            At Chryselys, he drives transformative initiatives across HCP
            analytics, patient analytics, and field force operations -
            leveraging data strategy and agentic AI to deliver innovative,
            high-impact solutions that shape commercial success and influence
            the future of pharma analytics.
          </p>
        </>
      ),
    },
    
    
   
   
  ];

  return (
    <>
      <section
        className="speakers our-team spacing position-relative bg-light-green"
        data-aos="fade-up"
      >
        <div className="container">
          <div className="d-flex flex-column flex-md-row flex-lg-row align-items-center justify-content-between">
            <div className="text-center w-100">
              <h4 className="title mb-3 text-primary fw-bold text-center">
                Meet the Speakers
              </h4>
            </div>
          </div>
          <div className="team-list">
            {/* <Carousel {...carouselConfig} ref={carouselRef}> */}
            <Row
              gutter={[
                { xs: 0, sm: 3, md: 3, lg: 3 },
                { xs: 0, sm: 0, md: 0, lg: 0 },
              ]}
            >
              {SpeakersData.map((members, i) => (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 8 }}
                  lg={{ span: 6 }}
                  key={i}
                >
                  <div
                    className="team-details position-relative cursor-pointer"
                    onClick={() => handleShowData(members)}
                  >
                    <div className="profile-image rounded overflow-hidden">
                      <img
                        src={members.profileImage}
                        alt={members.name}
                        className="w-100 rounded"
                      />
                    </div>
                    <div className="details text-center card">
                      <h4 className="font-4 font-weight-bold mb-1">
                        {members.name}
                      </h4>
                      <p className="text-ellipsis2 mb-0">
                        {members.companyName || members.position}
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            {/* </Carousel> */}
          </div>
        </div>
      </section>

      <ModalBox
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <div className="speaker-profile-informations">
          <Row
            gutter={[
              { xs: 0, sm: 16, md: 24, lg: 32 },
              { xs: 0, sm: 16, md: 24, lg: 20 },
            ]}
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 9 }}
              lg={{ span: 9 }}
            >
              <div className="profile-image rounded overflow-hidden">
                <img
                  src={showData.profileImage}
                  alt={showData.name}
                  className="w-100 rounded"
                />
              </div>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 15 }}
              lg={{ span: 15 }}
            >
              <div className="details text-left p-0">
                <h4 className="text-primary mb-1 border-bottom pb-2 mb-3">
                  <span className=" font-weight-bold">{showData.name}</span>
                  <span className="font-2 fon-weight-normal text-primary d-block">
                    {showData.position}
                    {showData.position && showData.companyName ? ", " : ""}
                    <strong>{showData.companyName}</strong>
                  </span>
                </h4>

                <div className="profile-desc">{showData.desc}</div>
              </div>
            </Col>
          </Row>
        </div>
      </ModalBox>
    </>
  );
}
